import React from 'react';
import { Button, Popconfirm, Tag } from 'antd';
import { Dataset } from '../../../types/dataset';
import { useAuthenticationContext } from '../../authentication/AuthenticationContext';
import { userIsAdmin } from '../../../lib/util';
import { Link } from 'react-router-dom';

export const GetProjectOverviewTableColumns = (
  onClickUrl: (dataset: Dataset) => string,
  onDelete: (e: any, dataset: Dataset) => any,
  onRename: (e: any, dataset: Dataset) => any
) => {
  const { currentUser } = useAuthenticationContext();

  return [
    {
      title: 'Name',
      key: 'fileName',
      dataIndex: 'fileName',
      render: (text: string, dataset: Dataset) => (
        <span>
          <Link style={{ color: '#1585FF' }} to={onClickUrl(dataset)}>
            {dataset.name}
          </Link>
        </span>
      ),
    },
    {
      title: 'Dataset Size',
      key: 'document_count',
      dataIndex: 'document_count',
      render: (text: number, dataset: Dataset) => (
        <span>
          <Tag color={'grey'} key={'Size'}>
            {dataset.latestVersion.document_count} documents
          </Tag>
        </span>
      ),
    },
    {
      title: 'Versions',
      key: 'version_count',
      dataIndex: 'version_count',
      render: (text: number, dataset: Dataset) => (
        <span>
          <Tag color={'grey'} key={'Size'}>
            {text === 1 ? `${dataset.version_count} version` : `${dataset.version_count} versions`}
          </Tag>
        </span>
      ),
    },
    {
      title: 'Status',
      key: 'status',
      dataIndex: 'status',
      render: (text: string, dataset: Dataset) => (
        <span>
          <Tag color={dataset.latestVersion.new_document_count === 0 ? 'green' : 'red'} key={'READY'}>
            {dataset.latestVersion.new_document_count === 0 ? 'no new documents' : 'new documents'}
          </Tag>
        </span>
      ),
    },
    {
      title: 'Actions',
      key: 'actions',
      dataIndex: 'actions',
      className: userIsAdmin(currentUser) ? '' : 'ant-column-hide',
      render: (text: string, dataset: Dataset) => (
        <span>
          <Popconfirm
            title="Are you sure to delete this dataset?"
            onConfirm={e => onDelete(e, dataset)}
            okText="Yes"
            cancelText="No">
            <Button type="link" size="small" disabled={!userIsAdmin(currentUser)}>
              Delete
            </Button>
          </Popconfirm>
          <span>
            <Button type="link" size="small" disabled={!userIsAdmin(currentUser)} onClick={e => onRename(e, dataset)}>
              Rename
            </Button>
          </span>
        </span>
      ),
    },
  ];
};
